import { SocialCardsList } from '@sapientpro/sapientpro-data-models';
import styles from './SocialCards.module.scss';
import SocialCardItem from './SocialCardItem';

const SocialCards = ({ data }: { data: SocialCardsList }) => (
  <section className={styles.socialCardsSection}>
    {data.socials.map(social => (
      <SocialCardItem
        key={social.id}
        item={social}
      />
    ))}
  </section>
);

export default SocialCards;
